import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export const FAQ = ({ items, title = "Frequently Asked Questions" }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Generate FAQ schema for SEO
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <section className="section-padding" data-testid="faq-section">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-center mb-12 uppercase tracking-wider">
            {title}
          </h2>
          
          <div className="space-y-0 border-t border-white/10">
            {items.map((item, index) => (
              <div 
                key={index}
                className="faq-item"
                data-testid={`faq-item-${index}`}
              >
                <button
                  onClick={() => toggleItem(index)}
                  className="faq-question w-full text-left"
                  data-testid={`faq-question-${index}`}
                  aria-expanded={openIndex === index}
                >
                  <span className="pr-8 font-heading text-lg">{item.question}</span>
                  <ChevronDown 
                    className={`w-5 h-5 text-cyan-400 transition-transform duration-300 flex-shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`} 
                  />
                </button>
                
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <p 
                        className="faq-answer"
                        data-testid={`faq-answer-${index}`}
                      >
                        {item.answer}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Schema markup for SEO */}
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </section>
  );
};
